module.exports = __webpack_public_path__ + "static/media/How to characterize a document under a folder or with document type.9f59e8c7.png";